import React from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Title, Button } from "../theme";

const rowContainer = {
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #444",
  padding: "1rem",
  minHeight: "300px",
  color: "white",
};

const imageColumn = {
  flex: "0 0 300px",
  textAlign: "center",
};

const imageStyle = {
  maxHeight: "250px",
  maxWidth: "100%",
  objectFit: "contain",
  borderRadius: "8px",
};

const buttonColumn = {
  flex: "0 0 120px",
  textAlign: "center",
};

const tagsColumn = {
  flex: "1",
  fontSize: "0.95rem",
  paddingLeft: "2rem",
};

const topButtonRow = {
  display: "flex",
  gap: "1rem",
  marginBottom: "1.5rem",
};

const SimpleGallery = () => {
  const { edition } = useParams();
  const memes = useSelector((state) => state.data.memes);

  if (!memes) return null;

  const filtered = memes.filter((m) => m.edition === edition && m.img);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied to clipboard!");
  };

  const handleCopyAllImgUrls = () => {
    const allImgUrls = filtered.map((m) => m.img).join("\n");
    handleCopy(allImgUrls);
  };

  const handleCopyAllHtmlUrls = () => {
    const base = window.location.origin;
    const allHtmlUrls = filtered
      .map((m) => `${base}/gallery/${m._id}`)
      .join("\n");
    handleCopy(allHtmlUrls);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <Title>Gallery: {edition}</Title>

      <div style={topButtonRow}>
        <Button noUrl text="Copy all IMG URLs" action={handleCopyAllImgUrls} />
        <Button
          noUrl
          text="Copy all HTML URLs"
          action={handleCopyAllHtmlUrls}
        />
      </div>

      {filtered.map((m) => (
        <div key={m._id} style={rowContainer}>
          <div style={imageColumn}>
            <img src={m.img} alt={m.description || m._id} style={imageStyle} />
          </div>
          <div style={buttonColumn}>
            <Button
              noUrl
              text="Copy IMG URL"
              action={() => handleCopy(m.img)}
            />
          </div>
          <div style={buttonColumn}>
            <Button
              noUrl
              text="Copy HTML URL"
              action={() =>
                handleCopy(`${window.location.origin}/gallery/${m._id}`)
              }
            />
          </div>
          <div style={tagsColumn}>
            {m.taxonomy &&
              m.taxonomy.map((tag) => (
                <span
                  key={tag._id}
                  style={{ marginRight: "0.8rem", color: "white" }}
                >
                  #{tag.name}
                </span>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SimpleGallery;
